import { COMPANY_CONFIG } from '../../../constants/companyConfig';
import OrderReceiptAlternate from './orderReceiptAlternate';
import OrderReceiptDefault from './orderReceiptDefault';

const OrderReceiptNode = (props) => {
  const useAlternate = COMPANY_CONFIG.features?.customNodeHandling;
  return useAlternate ? (
    <OrderReceiptAlternate {...props} />
  ) : (
    <OrderReceiptDefault {...props} />
  );
};

export default OrderReceiptNode;
